// extracted by mini-css-extract-plugin
export default {"highlight":"MessageOffline_highlight__Gd+DU","title":"MessageOffline_title__McW8p","subTitle":"MessageOffline_subTitle__lGRIe","image":"MessageOffline_image__ol59l"};